import React from "react";
import type { ButtonProps } from "@picklebet/ui";
import { ButtonGroup } from "@picklebet/ui";
import { LinkButton } from "@/features/shell/components/shared/LinkButton/LinkButton";
import { useIsMobile } from "@/hooks/useDisplay";
import { usePermissions } from "@/features/auth/hooks/usePermission";
import { useIsClient } from "@/hooks/useIsClient";
import { useHomeUrl } from "@/hooks/firestore/user/usePreferences";

type NextBettingButtonsProps = Partial<{
  className: string;
  size: ButtonProps["size"];
  variant: ButtonProps["variant"];
  buttonClass?: string;
}>;

const NextBettingButtons = ({
  className,
  size = "default",
  variant,
  buttonClass,
}: NextBettingButtonsProps) => {
  const isClient = useIsClient();
  const isMobile = useIsMobile();
  const btnSize = isMobile ? "md" : size;

  const permissions = usePermissions();
  const { homeUrl } = useHomeUrl();

  if (!isClient) return null;

  const buttons: React.ReactNode[] = [];

  if (permissions.viewEsportsMarkets === "GRANTED") {
    buttons.push(
      <LinkButton
        className={buttonClass}
        key="esports"
        variant={variant}
        size={btnSize}
        to="/betting"
      >
        Next Esports
      </LinkButton>,
    );
  }

  if (permissions.viewSportsMarkets === "GRANTED") {
    buttons.push(
      <LinkButton
        className={buttonClass}
        key="sports"
        variant={variant}
        size={btnSize}
        to="/sports/betting"
      >
        Next Sports
      </LinkButton>,
    );
  }

  if (permissions.viewRacingMarkets === "GRANTED") {
    buttons.push(
      <LinkButton
        className={buttonClass}
        key="racing"
        variant={variant}
        size={btnSize}
        to="/racing/betting"
      >
        Next Race
      </LinkButton>,
    );
  }

  if (buttons.length === 0) {
    buttons.push(
      <LinkButton
        className={buttonClass}
        key="home"
        variant={variant}
        size={btnSize}
        to={homeUrl}
      >
        Go home
      </LinkButton>,
    );
  }

  return <ButtonGroup className={className}>{buttons}</ButtonGroup>;
};

export default NextBettingButtons;
